export default __webpack_public_path__ + "static/media/jebing.21a3bf92.svg";